function normalizePath(path, options = {}) {
  const { addLeadingSlash = false, addTrailingSlash = false } = options;
  let base = path.split("/").filter((e) => !!e).join("/");
  if (addLeadingSlash) base = `/${base}`;
  if (addTrailingSlash) base = `${base}/`;
  return base;
}
function getPathVariables(pathTemplate) {
  const path = normalizePath(pathTemplate.replaceAll(" ", ""));
  const varMatches = path.match(/{{([a-zA-Z0-9-_ ]*?)}}/g);
  return varMatches?.map(
    (varMatch) => varMatch.replace("{{", "").replace("}}", "")
  ) ?? [];
}
function substitutePathVariables(pathTemplate, substitutions) {
  let path = normalizePath(pathTemplate.replaceAll(" ", ""));
  const pathVariables = getPathVariables(pathTemplate);
  pathVariables.forEach((key) => {
    if (substitutions[key]) {
      path = path.replace(`{{${key}}}`, substitutions[key]);
    }
  });
  return path;
}
export {
  getPathVariables,
  normalizePath,
  substitutePathVariables
};
//# sourceMappingURL=path.js.map
